<template>
    <div>
      <el-form ref="userId"  label-width="100px">
        <el-row>
          <el-col>
              <el-form-item label="角色名称：">
                <el-select filterable  v-model="userId" multiple placeholder="请选择角色名称" style="width:100%">
                  <el-option
                    v-for="item in RoleList"
                    :key="item.value"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div style="text-align:center;">
            <el-button @click="$emit('update:visibles',false)">取消</el-button>
             <el-button type="primary" @click="submit()">提交</el-button>
        </div>
    </div>
</template>
<script>
export default {
  components: {

  },
  props: {
    row: {
      type: Object
    }
  },
  data () {
    return {
      userId: [],
      RoleList: []
    }
  },
  methods: {
    // 新增
    add_data () {
    },
    // 查询数据
    search_data (row, type) {
      this.matterParams.current = 1

      Object.assign(this.matterParams, row)
      this.Render()
    },
    // 列表按钮
    event_button (row, type) {
    },
    // 列表数据
    Render () {
      this.$http.get('/ucenter/role/queryPullList').then((res) => {
        this.RoleList = res.data
      })
    },
    // 提交
    submit () {
      var data = {
        roleIds: this.userId,
        userId: this.row.id
      }
      this.$http.post('/ucenter/role/saveUserRole', data).then((res) => {
        if (res.status === 200) {
          this.$message.success('成功')
          this.$emit('update:visibles', false)
          this.$emit('Render')
        } else {
          this.$message.error('失败')
          this.$emit('update:visibles', true)
        }
      })
    }
  },
  created () {
    this.Render()
    this.userId = this.row.roleList
  },
  watch: {
  },
  mounted () {
  }
}
</script>
<style lang="scss" scoped>

</style>
